import * as React from 'react'
import { ForwardedRef, ReactElement } from 'react'
import useCurrency from '../../hooks/useCurrency'
import FormattableNumberInput, { FormattableNumberInputProps } from './FormattableNumberInput'

export type MoneyInputProps = FormattableNumberInputProps & {
    currency: string
}

function MoneyInput(props: MoneyInputProps, ref: ForwardedRef<HTMLInputElement>): ReactElement {
    const { currency } = useCurrency(props.currency)

    return <FormattableNumberInput {...props} decimals={props.decimals ?? currency.decimals} symbol={currency.symbol} ref={ref} />
}

export default React.forwardRef(MoneyInput)
